/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".field-icon[_ngcontent-%COMP%] {\n  position: absolute;\n  right: 20px;\n  padding: 0.7em;\n  z-index: 2; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.scss.shim.ngstyle.js.pre-build-optimizer.js